<template>
  <AppHeader />

  <q-page-container class="page-container">
    <q-page class="page" :style-fn="pageStyleFn">

      <router-view v-slot="{ Component }">
        <Suspense timeout="0">
          <template #default>
            <component :is="Component" :key="$route.path" />
          </template>

          <template #fallback>
            <q-inner-loading showing>
              <AppLoader />
            </q-inner-loading>
          </template>
        </Suspense>
      </router-view>

    </q-page>
  </q-page-container>

  <q-inner-loading :showing="isLoading">
    <AppLoader />
  </q-inner-loading>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import AppHeader from '~components/AppHeader.vue';
import AppLoader from '~components/AppLoader.vue';

defineProps({
  isLoading: {
    type: Boolean as PropType<boolean>,
  },
});

const pageStyleFn = () => ({});
</script>

<style>
/* .base-wrapper {
  position: relative;
  z-index: 1000;
  width: 100%;

  padding-top: 150px;
  padding-bottom: 70px;

} */
.page-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page {
  flex: 1;
}
</style>
